import React from "react";
import Header from "components/headers/lp-header";
import Footer from "components/footers/lp-footer";
import Cookie from "components/cookie/CookieSettings";

export default () => {
  return (
    <>
      <Header />
      {/* classNameを追加 */}
      <div className="content-container">
        <Cookie />
      </div>
      <Footer />
    </>
  );
};
